/**
 * Форматирует сумму в USD с двумя знаками после запятой.
 * Отсутствующее значение (ещё не подтянутый курс) рендерится пустой строкой.
 * Это общее правило проекта для отсутствующих значений: не прочерк.
 */
export const formatUsd = (value?: number | null): string =>
  value == null ? "" : value.toFixed(2);
